/* ============================================================
   VIGOREM NAD+ (slug 'vigorem') — suplemento NAD+ para hombres.

   Producto Shopify "SELERB NAD MENS COMPLEX" (8702900666529).
   Cada tier es UNA variante per-unit con el MISMO SKU 2051 (el que Dropi ya
   tiene mapeado), y la landing manda quantity = N:
     1 Frasco             -> $84.900    x1 = $84.900
     Compra 1, Lleva 1    -> $64.950    x2 = $129.900
     Compra 2, Lleva 1    -> $56.633,33 x3 = $169.900
   Así el total cuadra con lo que muestra la landing Y el pedido lleva los
   frascos reales para que Dropi despache la cantidad correcta.
   Requiere quantityControlsHidden:true en Releasit (ya global) para que el
   cliente no pueda cambiar la cantidad y desarmar el precio.
   Ver memory/project_releasit_cod_pattern y memory/project_bundles_as_variants.
   ============================================================ */
(function () {
  var root = document.querySelector('.vigorem-landing');
  if (!root) return;

  /* ============================================================
     1. Countdown de 6h (persistente por sesión)
     ============================================================ */
  (function () {
    var h = document.getElementById('cd-h'), m = document.getElementById('cd-m'), s = document.getElementById('cd-s');
    if (!h || !m || !s) return;
    var KEY = 'nx-cd-end';
    var end;
    try { end = sessionStorage.getItem(KEY); } catch (e) { end = null; }
    if (!end) {
      end = Date.now() + 6 * 3600 * 1000;
      try { sessionStorage.setItem(KEY, end); } catch (e) {}
    }
    var pad = function (n) { return String(n).padStart(2, '0'); };
    setInterval(function () {
      var d = Math.max(0, end - Date.now());
      h.textContent = pad(Math.floor(d / 3600000));
      m.textContent = pad(Math.floor(d % 3600000 / 60000));
      s.textContent = pad(Math.floor(d % 60000 / 1000));
    }, 500);
  })();

  /* ============================================================
     2. Galería
     ============================================================ */
  root.querySelectorAll('#thumbs button').forEach(function (b) {
    b.addEventListener('click', function () {
      root.querySelectorAll('#thumbs button').forEach(function (x) { x.classList.remove('on'); });
      b.classList.add('on');
      var main = document.getElementById('gal-main');
      if (main && b.dataset.src) main.src = b.dataset.src;
    });
  });

  /* ============================================================
     3. Releasit COD — variante + cantidad en el DOM, click botón nativo
     ============================================================ */
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
      input.value = variantId;
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
      input.value = variantId;
    });
    // Releasit lee la cantidad de input[name="quantity"] al abrir el modal
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      input.value = String(q);
      input.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  function clickNativeReleasit() {
    var rb = findReleasitButton();
    if (rb) { rb.click(); return; }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var b = findReleasitButton();
      if (b) { clearInterval(poll); b.click(); return; }
      if (attempts > 30) {
        clearInterval(poll);
        // último recurso: abre el modal con la variante que Releasit cacheó
        if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
          try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
        }
      }
    }, 100);
  }

  /* ============================================================
     4. Selección de tier
     ============================================================ */
  var selVariantId = null, selQty = 1;
  var tiers = root.querySelectorAll('.nx-tier');

  function pickTier(t) {
    tiers.forEach(function (x) { x.classList.remove('sel'); });
    t.classList.add('sel');
    var id = t.getAttribute('data-bundle-variant-id');
    if (id) {
      selVariantId = id;
      selQty = parseInt(t.getAttribute('data-qty'), 10) || 1;
      setVariantOnAllForms(selVariantId, selQty);
    }
  }
  tiers.forEach(function (t) { t.addEventListener('click', function () { pickTier(t); }); });

  window.vigoremTriggerCOD = function () {
    if (!selVariantId) return;
    setVariantOnAllForms(selVariantId, selQty);
    setTimeout(clickNativeReleasit, 50);
  };

  root.querySelectorAll('.js-cod').forEach(function (btn) {
    btn.addEventListener('click', function () { window.vigoremTriggerCOD(); });
  });

  /* init: tier preseleccionado (.sel o el primero) */
  var active = root.querySelector('.nx-tier.sel') || tiers[0];
  if (active) pickTier(active);

  /* ============================================================
     5. Barra sticky
     ============================================================ */
  var hero = root.querySelector('.nx-hero');
  var sticky = document.getElementById('sticky');
  if (hero && sticky) {
    window.addEventListener('scroll', function () {
      sticky.classList.toggle('show', window.scrollY > hero.offsetTop + hero.offsetHeight);
    });
  }
})();
